"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FacetFilterCategory = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _FacetFilterHeader = require("../FacetFilterHeader");
var _FilterOption = require("../FilterOption");
var _isColorOption = require("../FilterOption/utils/isColorOption");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FacetFilterCategory = (param)=>{
    let { category, openedCategory, onCategoryClick, onOptionClick, categoryRef, isFirst } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const isSelectedCategory = openedCategory === category.key;
    const selectedItemsCount = (0, _react.useMemo)(()=>category.items.filter((item)=>item.selected).length, [
        category.items
    ]);
    const onCategoryClickInternal = (0, _react.useCallback)(()=>{
        onCategoryClick(category.key);
    }, [
        category.key,
        onCategoryClick
    ]);
    const onOptionClickInternal = (0, _react.useCallback)((value)=>()=>{
            onOptionClick(category.key, value);
        }, [
        category.key,
        onOptionClick
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Category, {
        ref: categoryRef,
        "data-testid": getTestId("".concat(_constants.FACET_FILTER_CATEGORY, "-").concat(category.key)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FacetFilterHeader.FacetFilterHeader, {
                title: category.label,
                isOpen: isSelectedCategory,
                amountTotal: category.items.length,
                amountSelected: selectedItemsCount,
                isFirst: isFirst,
                onClick: onCategoryClickInternal
            }),
            isSelectedCategory ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Container, {
                children: category.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_FilterOption.FilterOption, {
                        count: item.count,
                        label: item.label,
                        selected: item.selected,
                        value: item.value,
                        type: item.type,
                        hexColors: (0, _isColorOption.isColorOption)(item) ? item.hexColors : undefined,
                        onClick: onOptionClickInternal(item.value)
                    }, item.value))
            }) : null
        ]
    }, category.key);
};
exports.FacetFilterCategory = FacetFilterCategory;
